import React from 'react';
import WIcon from './WIcon';

const TopHeader = ({ title, userInitials = 'AD', addLabel, onAdd, onSearch }) => {
  return (
    <header className="loysta-topbar">
      <h1 className="loysta-topbar-title">{title}</h1>
      <div className="loysta-topbar-actions">
        <div className="loysta-topbar-search">
          <WIcon name="search" size={15} color="#94a3b8" />
          <input
            type="text"
            placeholder="Search…"
            onChange={onSearch ? (e) => onSearch(e.target.value) : undefined}
          />
        </div>
        <button className="loysta-topbar-icon-btn" type="button">
          <WIcon name="bell" size={16} />
          <span className="badge" />
        </button>
        <div className="loysta-topbar-avatar">{userInitials}</div>
        {addLabel && onAdd && (
          <button type="button" className="loysta-topbar-add-btn" onClick={onAdd}>
            <WIcon name="plus" size={15} color="white" />
            {addLabel}
          </button>
        )}
      </div>
    </header>
  );
};

export default TopHeader;
